/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.Stakeholder = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The Stakeholder model module.
   * @module model/Stakeholder
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>Stakeholder</code>.
   * @alias module:model/Stakeholder
   * @class
   */
  var exports = function() {
    var _this = this;





























  };

  /**
   * Constructs a <code>Stakeholder</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Stakeholder} obj Optional instance to populate.
   * @return {module:model/Stakeholder} The populated <code>Stakeholder</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('TypeID')) {
        obj['TypeID'] = ApiClient.convertToType(data['TypeID'], 'Integer');
      }
      if (data.hasOwnProperty('MarketScopeTypeID')) {
        obj['MarketScopeTypeID'] = ApiClient.convertToType(data['MarketScopeTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('MarketScopeEntityID')) {
        obj['MarketScopeEntityID'] = ApiClient.convertToType(data['MarketScopeEntityID'], 'String');
      }
      if (data.hasOwnProperty('CountryID')) {
        obj['CountryID'] = ApiClient.convertToType(data['CountryID'], 'Integer');
      }
      if (data.hasOwnProperty('BusinessID')) {
        obj['BusinessID'] = ApiClient.convertToType(data['BusinessID'], 'String');
      }
      if (data.hasOwnProperty('HumanReadableBusinessID')) {
        obj['HumanReadableBusinessID'] = ApiClient.convertToType(data['HumanReadableBusinessID'], 'String');
      }
      if (data.hasOwnProperty('Description')) {
        obj['Description'] = ApiClient.convertToType(data['Description'], 'String');
      }
      if (data.hasOwnProperty('DomainURI')) {
        obj['DomainURI'] = ApiClient.convertToType(data['DomainURI'], 'String');
      }
      if (data.hasOwnProperty('BrandNames')) {
        obj['BrandNames'] = ApiClient.convertToType(data['BrandNames'], 'String');
      }
      if (data.hasOwnProperty('LocationLatitude')) {
        obj['LocationLatitude'] = ApiClient.convertToType(data['LocationLatitude'], 'Number');
      }
      if (data.hasOwnProperty('LocationLongitude')) {
        obj['LocationLongitude'] = ApiClient.convertToType(data['LocationLongitude'], 'Number');
      }
      if (data.hasOwnProperty('AddressLine')) {
        obj['AddressLine'] = ApiClient.convertToType(data['AddressLine'], 'String');
      }
      if (data.hasOwnProperty('Importance')) {
        obj['Importance'] = ApiClient.convertToType(data['Importance'], 'Integer');
      }
      if (data.hasOwnProperty('NewsModeratorID')) {
        obj['NewsModeratorID'] = ApiClient.convertToType(data['NewsModeratorID'], 'Integer');
      }
      if (data.hasOwnProperty('NewsWatchOn')) {
        obj['NewsWatchOn'] = ApiClient.convertToType(data['NewsWatchOn'], 'Boolean');
      }
      if (data.hasOwnProperty('NewsWatchFilterLevelID')) {
        obj['NewsWatchFilterLevelID'] = ApiClient.convertToType(data['NewsWatchFilterLevelID'], 'Integer');
      }
      if (data.hasOwnProperty('NewsWatchInitialRunDone')) {
        obj['NewsWatchInitialRunDone'] = ApiClient.convertToType(data['NewsWatchInitialRunDone'], 'Boolean');
      }
      if (data.hasOwnProperty('WebWatchOn')) {
        obj['WebWatchOn'] = ApiClient.convertToType(data['WebWatchOn'], 'Boolean');
      }
      if (data.hasOwnProperty('AdditionalMarketID')) {
        obj['AdditionalMarketID'] = ApiClient.convertToType(data['AdditionalMarketID'], 'Integer');
      }
      if (data.hasOwnProperty('TwitterWatchOn')) {
        obj['TwitterWatchOn'] = ApiClient.convertToType(data['TwitterWatchOn'], 'Boolean');
      }
      if (data.hasOwnProperty('Removed')) {
        obj['Removed'] = ApiClient.convertToType(data['Removed'], 'Date');
      }
      if (data.hasOwnProperty('MarketID')) {
        obj['MarketID'] = ApiClient.convertToType(data['MarketID'], 'Integer');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('FatherID')) {
        obj['FatherID'] = ApiClient.convertToType(data['FatherID'], 'Integer');
      }
      if (data.hasOwnProperty('ScopeEndSort')) {
        obj['ScopeEndSort'] = ApiClient.convertToType(data['ScopeEndSort'], 'Integer');
      }
      if (data.hasOwnProperty('DepthLevel')) {
        obj['DepthLevel'] = ApiClient.convertToType(data['DepthLevel'], 'Integer');
      }
      if (data.hasOwnProperty('Sort')) {
        obj['Sort'] = ApiClient.convertToType(data['Sort'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} TypeID
   * @default 0
   */
  exports.prototype['TypeID'] = 0;
  /**
   * @member {Integer} MarketScopeTypeID
   */
  exports.prototype['MarketScopeTypeID'] = undefined;
  /**
   * @member {String} MarketScopeEntityID
   * @default ''
   */
  exports.prototype['MarketScopeEntityID'] = '';
  /**
   * @member {Integer} CountryID
   */
  exports.prototype['CountryID'] = undefined;
  /**
   * @member {String} BusinessID
   * @default ''
   */
  exports.prototype['BusinessID'] = '';
  /**
   * @member {String} HumanReadableBusinessID
   * @default ''
   */
  exports.prototype['HumanReadableBusinessID'] = '';
  /**
   * @member {String} Description
   * @default ''
   */
  exports.prototype['Description'] = '';
  /**
   * @member {String} DomainURI
   * @default ''
   */
  exports.prototype['DomainURI'] = '';
  /**
   * @member {String} BrandNames
   * @default ''
   */
  exports.prototype['BrandNames'] = '';
  /**
   * @member {Number} LocationLatitude
   */
  exports.prototype['LocationLatitude'] = undefined;
  /**
   * @member {Number} LocationLongitude
   */
  exports.prototype['LocationLongitude'] = undefined;
  /**
   * @member {String} AddressLine
   * @default ''
   */
  exports.prototype['AddressLine'] = '';
  /**
   * @member {Integer} Importance
   */
  exports.prototype['Importance'] = undefined;
  /**
   * @member {Integer} NewsModeratorID
   */
  exports.prototype['NewsModeratorID'] = undefined;
  /**
   * @member {Boolean} NewsWatchOn
   * @default false
   */
  exports.prototype['NewsWatchOn'] = false;
  /**
   * @member {Integer} NewsWatchFilterLevelID
   */
  exports.prototype['NewsWatchFilterLevelID'] = undefined;
  /**
   * @member {Boolean} NewsWatchInitialRunDone
   * @default false
   */
  exports.prototype['NewsWatchInitialRunDone'] = false;
  /**
   * @member {Boolean} WebWatchOn
   * @default false
   */
  exports.prototype['WebWatchOn'] = false;
  /**
   * @member {Integer} AdditionalMarketID
   */
  exports.prototype['AdditionalMarketID'] = undefined;
  /**
   * @member {Boolean} TwitterWatchOn
   * @default false
   */
  exports.prototype['TwitterWatchOn'] = false;
  /**
   * @member {Date} Removed
   */
  exports.prototype['Removed'] = undefined;
  /**
   * @member {Integer} MarketID
   */
  exports.prototype['MarketID'] = undefined;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} FatherID
   */
  exports.prototype['FatherID'] = undefined;
  /**
   * @member {Integer} ScopeEndSort
   * @default 0
   */
  exports.prototype['ScopeEndSort'] = 0;
  /**
   * @member {Integer} DepthLevel
   * @default 0
   */
  exports.prototype['DepthLevel'] = 0;
  /**
   * @member {Integer} Sort
   * @default 0
   */
  exports.prototype['Sort'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


